module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel-suns_spot_03-63ae48cf29244510c403e02d332f3c26.jpg";